import { Toaster as Sonner } from 'sonner';

type ToasterProps = React.ComponentProps<typeof Sonner>;

function Toaster({ ...props }: ToasterProps) {
  return (
    <Sonner
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-surface-raised-light group-[.toaster]:text-text-primary-light group-[.toaster]:border-border-subtle-light group-[.toaster]:shadow-card dark:group-[.toaster]:bg-surface-raised-dark dark:group-[.toaster]:text-text-primary-dark dark:group-[.toaster]:border-border-subtle-dark',
          description:
            'group-[.toast]:text-text-secondary-light dark:group-[.toast]:text-text-secondary-dark',
          actionButton:
            'group-[.toast]:bg-primary-700 group-[.toast]:text-white',
          cancelButton:
            'group-[.toast]:bg-surface-hover-light group-[.toast]:text-text-secondary-light dark:group-[.toast]:bg-surface-raised-dark dark:group-[.toast]:text-text-secondary-dark',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
